import React, { useEffect } from 'react';
import axiosInstance, { getApiBaseUrl } from '../components/services/axiosInstance.js';


import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { FaStar } from 'react-icons/fa';

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(2),
  textAlign: 'center',
  color: theme.palette.text.secondary,
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  border: '1px solid',
  borderColor: theme.palette.divider,
  position: 'relative',
}));

const InstantBuyBadge = styled(Box)(() => ({
  position: 'absolute',
  top: 8,
  right: 8,
  backgroundColor: '#FD297B',  // Electric pink background
  color: '#fff',
  fontSize: '0.75rem',
  fontWeight: 'bold',
  padding: '4px 8px',
  borderRadius: '12px',
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
}));

const ProductGrid = ({ products = [], markedProducts = [], toggleMarkProduct, truncateDescription }) => {

  useEffect(() => {
    console.log('Fetched products:', products);
    console.log('Fetched marked products:', markedProducts);
  }, [products, markedProducts]);

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Grid container spacing={2}>
        {products.map(product => {
          const isMarked = markedProducts.some(item => item.product_id === product.id);
          return (
            <Grid item xs={12} sm={6} md={4} lg={3} xl={2} key={product.id}>
              <Item style={{ borderColor: isMarked ? '#FF5864' : '' }}>
                
                {/* Instant Buy Badge */}
                <InstantBuyBadge>
                  Instant Buy Repln
                </InstantBuyBadge>

                <img
                  src={product.image_url1}
                  alt={product.product_name}
                  style={{ maxWidth: '100%', maxHeight: '200px', objectFit: 'contain' }}
                />
                <div className="product-info">
                  <Typography variant="h6" sx={{ mb: 1 }}>{product.product_name}</Typography>
                  <Typography variant="body2" paragraph>
                    {truncateDescription(product.product_description, 50)}
                  </Typography>
                  <Typography variant="body1">
                    {new Intl.NumberFormat(undefined).format(product.price_gross)} {product.currency || 'USD'}
                  </Typography>

                  <IconButton
                    onClick={() => toggleMarkProduct(product.id)}
                    color="primary"
                  >
                    <FaStar style={{ color: isMarked ? '#FF5864' : '#ccc' }} />
                  </IconButton>
                </div>
              </Item>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
};

export default ProductGrid;
